
import { defineComponent, onMounted, onUnmounted, ref } from 'vue';
import HomeHeader from '@/components/HomeHeader.vue';
import HomeList from '@/components/HomeList.vue';
import HomeFooter from '@/components/HomeFooter.vue';
import { installPassportNotInLoginPage, isProd, syncCookieToken } from '../services/base.js';
import { Spin } from 'ant-design-vue';
import { isKangeHong } from '@/utils/project';
import useKeepalive from '@/components/hooks/useKeepalive';

export default defineComponent({
  name: 'Home',
  components: {
    HomeHeader,
    HomeList,
    HomeFooter,
    ASpin: Spin
  },
  setup() {
    syncCookieToken();
    if (isProd()) {
      installPassportNotInLoginPage();
    }
    // 添加判断的loading时间
    const loading = ref(true);
    const { doKeepalive, unlockKeepalive, restartKeepalive } = useKeepalive();
    setTimeout(() => {
      loading.value = false;
    }, 800);
    onMounted(() => {
      //针对康宏项目，登录系统后8小时内登录均有效，帮助续租。
      if (isKangeHong()) {
        doKeepalive();
      }
    });
    onUnmounted(() => {
      unlockKeepalive();
    });
    return {
      loading,
    };
  }
});
